import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { ResponseGetSpCheck } from 'src/utilities/restApi/common/types/spCheck';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

const url = '/spcheck';

export const getSpCheck = async () => {
  const headers = { headers: await getCommonHeaders() };
  const config = { ...headers };

  return new Promise<SuccessResponse<ResponseGetSpCheck>>((resolve, reject) => {
    restApi()
      .get<SuccessResponse<ResponseGetSpCheck>>(url, config)
      .then((response) => {
        resolve(response.data!);
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        reject(error.response?.data);
      });
  });
};
